import React, { FC } from 'react';

import { BUTTON_TYPES, EvBodyMedium, EvError, EvFlexColumn } from '@evinced-private/ui-common';

import {
	LABEL_MANAGEMENT_DELETE_CONFIRM_CANCEL_DAID,
	LABEL_MANAGEMENT_DELETE_CONFIRM_DAID,
	LABEL_MANAGEMENT_DELETE_CONFIRM_MODAL_DAID
} from 'data-automation-ids/LabelManagementAutomationIds';
import { PlatformPopup } from 'src/common/components/platform-popup/PlatformPopup';

import { DELETE_LABEL_MODAL_LABELS } from './DeleteLabelConfirmModal.labels';
import { DeleteLabelConfirmModalProps } from './DeleteLabelConfirmModal.types';

export const DeleteLabelConfirmModal: FC<DeleteLabelConfirmModalProps> = ({
	label,
	isDeleting,
	deleteError,
	onConfirm,
	onCancel
}) => {
	if (!label) {
		return null;
	}

	return (
		<PlatformPopup
			isControlled
			isOpen
			isCentered
			isBgTransparent
			title={DELETE_LABEL_MODAL_LABELS.TITLE}
			onClose={onCancel}
			isPopupLoading={isDeleting}
			buttons={[
				{
					onClick: onCancel,
					title: DELETE_LABEL_MODAL_LABELS.CANCEL,
					type: BUTTON_TYPES.SECONDARY,
					dataAutomationId: LABEL_MANAGEMENT_DELETE_CONFIRM_CANCEL_DAID
				},
				{
					onClick: onConfirm,
					title: DELETE_LABEL_MODAL_LABELS.CONFIRM,
					type: BUTTON_TYPES.PRIMARY,
					disabled: isDeleting,
					dataAutomationId: LABEL_MANAGEMENT_DELETE_CONFIRM_DAID
				}
			]}
		>
			<EvFlexColumn dataAutomationId={LABEL_MANAGEMENT_DELETE_CONFIRM_MODAL_DAID} gap="MEDIUM">
				{deleteError ? <EvError error={deleteError} /> : null}
				<EvBodyMedium>
					{DELETE_LABEL_MODAL_LABELS.BODY_PREFIX}
					<strong>&quot;{label.displayName}&quot;</strong>
					{DELETE_LABEL_MODAL_LABELS.BODY_SUFFIX}
				</EvBodyMedium>
			</EvFlexColumn>
		</PlatformPopup>
	);
};
